var _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuvette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 11,
    viewBox: "0 0 28 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H28L18 5H0L9 0Z",
    fill: "#ED3431"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 18,
    height: 2,
    fill: "#8E1F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5L28 0V2L18 7V5Z",
    fill: "#BE2A27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 17,
    height: 4,
    fill: "#5F1514"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7L27 2.5V6.5L19 10.5L18 11V7Z",
    fill: "#8E1F1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuvette);
export default __webpack_public_path__ + "static/media/Cuvette.2697a1a183ba955983c764fd5d28670e.svg";
export { ForwardRef as ReactComponent };